// extracted by mini-css-extract-plugin
export var attachmentContainer = "_o0-0";
export var fileList = "_o0-2";
export var removeFileButton = "_o0-1";